import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
});

let accessToken = null;
export const setAccessToken = (t) => {
    accessToken = t || null;
};
export const getAccessToken = () => accessToken;
// Security: token kept in memory only (HttpOnly cookie carries the session).
try { localStorage.removeItem("ai_access_token"); } catch { /* noop */ }

api.interceptors.request.use((config) => {
    const t = getAccessToken();
    if (t && !config.headers.Authorization) {
        config.headers.Authorization = `Bearer ${t}`;
    }
    return config;
});

export default api;

export function formatApiError(detail) {
    if (detail == null) return "Si è verificato un errore. Riprova.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.message === "string") return detail.message;
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
